import { 
  SMART_EDIT_STATUS_FAILURE, 
  SMART_EDIT_STATUS_LOADING, 
  SMART_EDIT_STATUS_SUCCESS, 
  SMART_EDIT_TOP_CLAIM_FAILURE, 
  SMART_EDIT_TOP_CLAIM_LOADING, 
  SMART_EDIT_TOP_CLAIM_SUCCESS, 
  SMART_EDIT_TOP_REASONS_FAILURE, 
  SMART_EDIT_TOP_REASONS_LOADING, 
  SMART_EDIT_TOP_REASONS_SUCCESS, 
  SMART_EDITS_SUMMARY_FAILURE, 
  SMART_EDITS_SUMMARY_LOADING, 
  SMART_EDITS_SUMMARY_SUCCESS
} from "@src/middleware/actions/actionTypes";
import { SMART_EDIT_OVER_TIMES_FAILURE, SMART_EDIT_OVER_TIMES_LOADING, SMART_EDIT_OVER_TIMES_SUCCESS } from "@src/middleware/actions/ServiceInteraction/DigitalSolutions/sm.ActionTypes";


interface SmartEditsState {
  smartEditsSummaryData: any;
  smartEditsSummaryIsLoading: boolean;
  smartEditsSummaryError: string | null;
  smartEditStatusData: any;
  smartEditStatusIsLoading: boolean;
  smartEditStatusError: string | null;
  smartEditTopReasonsData: any;
  smartEditTopReasonsIsLoading: boolean;
  smartEditTopReasonsError: string | null;
  smartEditOverTimesData: any;
  smartEditOverTimesIsLoading: boolean;
  smartEditOverTimesError: string | null;
  smartEditTopClaimData: any;
  smartEditTopClaimIsLoading: boolean;
  smartEditTopClaimError: string | null;
}

const initialState: SmartEditsState = {
  smartEditsSummaryData: {},
  smartEditsSummaryIsLoading: false,
  smartEditsSummaryError: null,
  smartEditStatusData: {},
  smartEditStatusIsLoading: false,
  smartEditStatusError: null,
  smartEditTopReasonsData: {},
  smartEditTopReasonsIsLoading: false,
  smartEditTopReasonsError: null,
  smartEditOverTimesData: {},
  smartEditOverTimesIsLoading: false,
  smartEditOverTimesError: null,
  smartEditTopClaimData: {},
  smartEditTopClaimIsLoading: false,
  smartEditTopClaimError: null,
};

const SmartEditsReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): SmartEditsState => {
  switch (action.type) {
    case SMART_EDITS_SUMMARY_LOADING:
      return {
        ...state,
        smartEditsSummaryIsLoading: action.payload,
      };

    case SMART_EDITS_SUMMARY_SUCCESS:
      return {
        ...state,
        smartEditsSummaryData: action.payload,
      };

    case SMART_EDITS_SUMMARY_FAILURE:
      return {
        ...state,
        smartEditsSummaryError: action.payload,
      };

    case SMART_EDIT_STATUS_LOADING:
      return {
        ...state,
        smartEditStatusIsLoading: action.payload,
      };

    case SMART_EDIT_STATUS_SUCCESS:
      return {
        ...state,
        smartEditStatusData: action.payload,
      };

    case SMART_EDIT_STATUS_FAILURE:
      return {
        ...state,
        smartEditStatusError: action.payload,
      };

    case SMART_EDIT_TOP_REASONS_LOADING:
      return {
        ...state,
        smartEditTopReasonsIsLoading: action.payload,
      };

    case SMART_EDIT_TOP_REASONS_SUCCESS:
      return {
        ...state,
        smartEditTopReasonsData: action.payload,
      };    case SMART_EDIT_TOP_REASONS_FAILURE:
      return {
        ...state,
        smartEditTopReasonsError: action.payload,
      };
    case SMART_EDIT_OVER_TIMES_LOADING:
      return {
        ...state,
        smartEditOverTimesIsLoading: action.payload,
      };

    case SMART_EDIT_OVER_TIMES_SUCCESS:
      return {
        ...state,
        smartEditOverTimesData: action.payload,
      };

    case SMART_EDIT_OVER_TIMES_FAILURE:
      return {
        ...state,
        smartEditOverTimesError: action.payload,
         };
    case SMART_EDIT_TOP_CLAIM_LOADING:
      return {
        ...state,
        smartEditTopClaimIsLoading: action.payload,
      };

    case SMART_EDIT_TOP_CLAIM_SUCCESS:
      return {
        ...state,
        smartEditTopClaimData: action.payload,
      };

    case SMART_EDIT_TOP_CLAIM_FAILURE:
      return {
        ...state,
        smartEditTopClaimError: action.payload,
      };

    default:
      return state;
  }
};

export default SmartEditsReducer;
